import React, { useEffect, useState, useCallback } from 'react';
import { Spinner, Tab, Tabs } from 'react-bootstrap';
import { useHistory } from 'react-router-dom'
import { Button } from 'react-bootstrap';
import DataTableExtensions from 'react-data-table-component-extensions';
import DataTable from 'react-data-table-component';
import AresNavBar from '../../Layout/NavBar/NavBar';
import SideBar from '../../Layout/SideBar/SideBar';
import client from "../../../services/Api";
import moment from 'moment';
import { useAuth } from '../../../providers/auth';
import DisableUserModal from '../DisableUserModal';
import { ModalManager } from 'react-dynamic-modal/lib/Modal';

import AdminUserResetPassword from './ResetPassword'

import './index.css'

function UserScreen() {
    const [loading, setLoading] = useState(true);
    const [tableDataActives, setTableDataActives] = useState();
    const [tableDataInactives, setTableDataInactives] = useState();
    const [enterpriseId, setEnterpriseId] = useState();
    const [key, setKey] = useState('active');
    const history = useHistory();
    const { user } = useAuth();

    const tabController = useCallback((key) => {
        setKey(key)
    }, [])

    useEffect(() => {
        init()
    }, []);

    const columnsActive = [
        {
            name: 'Nome',
            selector: 'name',
            sortable: false,
            width: '20%',
        },
        {
            name: 'Data de criação',
            format: row => moment.utc(row.created_at).local().format('DD/MM/YYYY HH:mm:ss'),
            selector: 'created_at',
            sortable: false,
            width: '12%',
        },
        {
            name: 'dispositivos vinculados',
            selector: 'available_devices',
            format: row => row.available_devices != null ? row.available_devices.length : "--",
            sortable: false,
            width: '12%',
        },
        {
            cell: (row) =>
                tableActionsActive(row)
            ,
        }
    ];

    const columnsInactive = [
        {
            name: 'Nome',
            selector: 'name',
            sortable: false,
            width: '25%',
        },
        {
            name: 'Data de criação',
            format: row => moment.utc(row.created_at).local().format('DD/MM/YYYY HH:mm:ss'),
            selector: 'created_at',
            sortable: false,
            width: '12%',
        },
        {
            name: 'dispositivos vinculados',
            selector: 'available_devices',
            format: row => row.available_devices != null ? row.available_devices.length : "--",
            sortable: false,
            width: '12%',
        },
        {
            cell: (row) =>
                <div className="actions">
                    <button className="add-beacon edit-beacon" onClick={() =>
                        history.push(`/add-beacons?id=${row._id}&numDevices=${row.available_devices != null ? row.available_devices.length : 0}&eID=${enterpriseId}`)
                    }>
                        Dispositivos
                  </button>

                    <button className="add-beacon edit-beacon" onClick={() =>
                        history.push(`/edit-user?id=${row._id}`)
                    }>
                        Editar
                  </button>
                    <button className="add-beacon edit-beacon"
                        onClick={() => history.push(`/acess-log?user_id=${row._id}`)}>
                        Logs
                  </button>

                    <button className="add-beacon edit-beacon" onClick={() => openEnableUserModal(row._id, user.profile._id, false)}>
                        Ativar
                  </button>

                </div>
            ,
        }
    ];

    function renderLoading() {
        return (
            <div className="center-page">
                <Spinner animation="border" />
            </div>
        )
    }

    function openEnableUserModal(id, profileId, status) {
        ModalManager.open(<DisableUserModal onClose={init} user_id={id} userType={profileId} status={status} />)
    }

    async function init() {
        setLoading(true);
        const enterprise = await getEnterprise();
        const actives = await getActives(enterprise);
        const inactives = await getInactives(enterprise);

        setEnterpriseId(enterprise);
        setTableDataActives({
            data: actives,
            columns: columnsActive
        })
        setTableDataInactives({
            data: inactives,
            columns: columnsInactive
        })
        setLoading(false);
    }

    async function getEnterprise() {
        try {
            const response = await client.get(`/api/user-client-id/${user.id}`)
            const id = response.data._id;
            return id;
        } catch (e) {
            console.log(e)
        }
    }

    async function getActives(enterprise) {
        try {
            const response = await client.get(`/api/users-by-client/${enterprise}`, { params: { disabled: false } });
            return response.data;
        } catch (e) {
            console.log(e);
        }
        return null;
    }

    async function getInactives(enterprise) {
        try {
            const response = await client.get(`/api/users-by-client/${enterprise}`, { params: { disabled: true } });
            return response.data;
        } catch (e) {
            console.log(e);
        }
        return null;
    }

    function InactiveTable() {
        return (
            <DataTableExtensions
                {...tableDataInactives}
                filterPlaceholder="Pesquisar usuários"
                print={false}>
                <DataTable
                    noDataComponent={
                        <span>Nada encontrado.</span>
                    }
                    pagination={true}
                />
            </DataTableExtensions>
        );
    }

    function ActiveTable() {
        return (
            <DataTableExtensions
                {...tableDataActives}
                filterPlaceholder="Pesquisar usuários"
                print={false}>
                <DataTable
                    noDataComponent={
                        <span>Nada encontrado.</span>
                    }
                    pagination={true}
                />
            </DataTableExtensions>
        );
    }

    function tableActionsActive(row) {
        return (
            <div className="actions">
                <button className="btn action-button btn-primary" onClick={() =>
                    history.push(`/add-beacons?id=${row._id}&numDevices=${row.available_devices != null ? row.available_devices.length : 0}&eID=${enterpriseId}`)
                }>
                    Dispositivos
                  </button>

                <button className="btn action-button btn-secondary" onClick={() => ModalManager.open(<AdminUserResetPassword user={row} />)
                }>
                    Alterar senha
                  </button>


                <button className="btn action-button btn-info" onClick={() =>
                    history.push(`/edit-user?id=${row._id}`)
                }>
                    Editar
                  </button>

                <button className="btn action-button btn-success"
                    onClick={() => history.push(`/acess-log?user_id=${row._id}`)}>
                    Logs
                  </button>

                <button className="btn action-button btn-danger" onClick={() => openEnableUserModal(row._id, user.profile._id, true)}>
                    Desativar
                  </button>

            </div>
        )
    }

    function body() {
        return (
            <div className="content">
                <div>
                    <div className="container-header">
                        <h1>Usuários da empresa {user.enterprise.name}</h1>

                        <Button variant="primary" type="submit" onClick={() =>
                            history.push('/register-user')
                        }>
                            Cadastrar Novo Usuário
                </Button>
                    </div>
                </div>
                <div className="container-options-header">
                    <Tabs
                        id="controlled-tab"
                        activeKey={key}
                        onSelect={(k) => tabController(k)}
                        className="Tabs-beacon-devices"
                    >
                        <Tab eventKey="active" title="Ativos">
                            <div className="data-table-container CustomContainer">
                                {loading ?
                                    renderLoading()
                                    : ActiveTable()
                                }
                            </div>
                        </Tab>
                        <Tab eventKey="inactive" title="Inativos">
                            <div className="data-table-container" >
                                {loading ?
                                    renderLoading()
                                    : InactiveTable()
                                }
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        );
    }

    return (
        <div className="UserScreen sidenav-margin">
            <AresNavBar />
            <SideBar />
            {body()}
        </div>

    );
}

export default UserScreen;